import { render, staticRenderFns } from "./walletAccount.vue?vue&type=template&id=0fc456c5&scoped=true&"
import script from "./walletAccount.vue?vue&type=script&lang=js&"
export * from "./walletAccount.vue?vue&type=script&lang=js&"
import style0 from "./walletAccount.vue?vue&type=style&index=0&id=0fc456c5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc456c5",
  null
  
)

export default component.exports